interface SkeletonProps {
  className?: string
}

export function Skeleton({ className = '' }: SkeletonProps) {
  return (
    <div className={`skeleton-item bg-[#e7ebf3] dark:bg-white/10 rounded ${className}`} />
  )
}

export function StatCardSkeleton() {
  return (
    <div className="bg-white dark:bg-[#0d121b] p-5 rounded-xl border border-[#cfd7e7] dark:border-white/10 shadow-sm flex flex-col gap-4">
      <Skeleton className="h-9 w-9 rounded-lg" />
      <div className="flex flex-col gap-2">
        <Skeleton className="h-3 w-24 rounded-full" />
        <Skeleton className="h-7 w-16 rounded-md" />
      </div>
    </div>
  )
}

export function TableRowSkeleton({ cols = 5 }: { cols?: number }) {
  return (
    <tr>
      {Array.from({ length: cols }).map((_, i) => (
        <td key={i} className="px-6 py-4">
          <Skeleton className="h-4 w-full max-w-[120px] rounded-full" />
        </td>
      ))}
    </tr>
  )
}

export function LinkTableSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className="bg-white dark:bg-[#0d121b] rounded-xl border border-[#cfd7e7] dark:border-white/10 shadow-sm overflow-hidden">
      <div className="px-6 py-4 border-b border-[#e7ebf3] dark:border-white/10 flex items-center gap-2">
        <Skeleton className="h-4 w-28 rounded-full" />
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-[#f6f6f8] dark:bg-white/5 border-b border-[#e7ebf3] dark:border-white/10">
            <tr>
              {['Destination', 'Short URL', 'Clicks', 'Status', 'Actions'].map(h => (
                <th key={h} className="px-6 py-3 text-left text-[11px] font-semibold text-[#4c669a] dark:text-gray-400 uppercase tracking-wider">
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-[#e7ebf3] dark:divide-white/10">
            {Array.from({ length: rows }).map((_, i) => (
              <TableRowSkeleton key={i} cols={5} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
